/* eslint-disable no-nested-ternary */
import { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router-dom";
import { RootStateOrAny, useSelector } from "react-redux";
import { AuthState } from "store/ducks/auth/types";
import { CARGO_CODES } from "constants/permissions";
import { useListarFilaRecepcionista } from "services/api/RoletaRecepcionista/get-listar-fila";
import { usePlantaoVendas } from "contexts/PlantaoVendasContext";
import * as S from "./styles";
import NavCommon from "../../components/@navHeader";
import IniciarInscricoes from "./components/iniciarInscricoes";
import FilaInscricao from "./components/filaInscricao";
import OrdemFila from "./components/ordemFila";

const Roleta = () => {
  const history = useHistory();
  const { plantaoVendas: plantaoVendasRedux, codigoCargo2013 } = useSelector<
    RootStateOrAny,
    AuthState
  >((state) => state.user);

  const {
    plantaoVendas: plantaoVendasContext,
    setPlantaoVendas: setPlantaoVendasContext,
  } = usePlantaoVendas();

  const isCorretor = codigoCargo2013 === CARGO_CODES.CORRETOR;

  const [turno, setTurno] = useState<string | number>("");
  const [quantidade, setQuantidade] = useState<string>("");
  const [telaInicial, setTelaInicial] = useState<boolean>(false);
  const [isInitialized, setIsInitialized] = useState<boolean>(false);

  const idPlantaoVendasAtivo = isCorretor
    ? plantaoVendasContext?.value
    : plantaoVendasRedux?.id;

  const prevIdPlantaoVendas = useRef(idPlantaoVendasAtivo);

  const { data: dataListarFila, refetch: refetchListarFila } =
    useListarFilaRecepcionista({
      idPlantaoVendas: idPlantaoVendasAtivo,
      codigoTurno: turno,
      idRoletaCheckin: "",
    });

  useEffect(() => {
    if (dataListarFila && dataListarFila !== null) {
      setTelaInicial(true);
    } else setTelaInicial(false);
  }, [dataListarFila]);

  // Reset quando o corretor trocar de PDV
  useEffect(() => {
    if (
      isCorretor &&
      prevIdPlantaoVendas.current !== undefined &&
      prevIdPlantaoVendas.current !== idPlantaoVendasAtivo
    ) {
      setTurno("");
      setQuantidade("");
      setTelaInicial(false);
    }
    prevIdPlantaoVendas.current = idPlantaoVendasAtivo;
  }, [idPlantaoVendasAtivo, isCorretor]);

  // Reset ao entrar na tela pela primeira vez
  useEffect(() => {
    const shouldReset = sessionStorage.getItem("roletaResetNeeded");

    if (shouldReset === "true" || !isInitialized) {
      if (isCorretor) {
        setPlantaoVendasContext(null);
      }
      setTurno("");
      setQuantidade("");
      setTelaInicial(false);
      setIsInitialized(true);
      sessionStorage.removeItem("roletaResetNeeded");
    }

    // Marca para reset quando sair da página
    const handleBeforeUnload = () => {
      sessionStorage.setItem("roletaResetNeeded", "true");
    };

    // Marca para reset quando navegar
    const unlisten = history.listen((location) => {
      if (location.pathname !== "/roleta") {
        sessionStorage.setItem("roletaResetNeeded", "true");
      }
    });

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      unlisten();
    };
  }, [isInitialized, isCorretor, setPlantaoVendasContext, history]);

  return (
    <>
      <NavCommon
        breadcrumbs={[{ path: "/roleta", name: "Roleta" }]}
        onBack={() => {
          history.goBack();
        }}
        onChangeActionNew={() => history.push("/")}
      />
      <S.Content>
        <IniciarInscricoes
          dataListarFila={dataListarFila}
          plantaoVendasId={plantaoVendasRedux?.id}
          refetchListarFila={refetchListarFila}
          onChangeTurno={(turno) => {
            setTurno(turno);
          }}
          onChangeQuantidade={(quantidadeSelecionada) => {
            setQuantidade(quantidadeSelecionada);
          }}
        />

        {telaInicial ? (
          dataListarFila?.statusFila !== 3 ? (
            <FilaInscricao
              refetchListarFila={refetchListarFila}
              dataListarFila={dataListarFila}
            />
          ) : (
            <OrdemFila
              refetchListarFila={refetchListarFila}
              dataListarFila={dataListarFila}
            />
          )
        ) : null}
      </S.Content>
    </>
  );
};

export default Roleta;
